export default permissions => {
  let target = {}
  Object.keys(permissions).forEach(key => {
    const parent = permissions[key]
    const { enabled, status = null, ...keys } = parent
    // set parent keys as booleans
    if (status != null) {
      target[key] = status
    } else {
      target[key] = { enabled }
    }

    // if keys are present in below menu items then we are assigning out parent to target
    ;[
      'main_menu',
      'custom_main_menu',
      'plaid',
      'community_feed',
      'secondary_menu',
      'quick_links',
    ].includes(key)
      ? (target[key] = parent)
      : Object.entries(keys).forEach(([k, value]) => {
          target[k] = value
        })
  })

  return target
}
